// extracted by mini-css-extract-plugin
export default {"title":"FuqnOiQTdXA6iiPhm0pA","form":"Vpi3XVFZIDIzuNOvrJ2J","button":"wf7W1UW5jHN5rF6HEmns","disconnect":"NE7CSD79hInTv9nfPCgK"};